import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18next';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import LoaderElementFull from './components/LoaderElementFull';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <UserProvider>
    <React.Suspense fallback={<LoaderElementFull />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Suspense>
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
